import { Rectangle } from 'recharts';

/**
 * Recharts Styling Guidelines:
 * 1. Avoid using styled-components directly on Recharts core components (like XAxis, YAxis, Bar, ResponsiveContainer)
 *    as it can interfere with their internal rendering and functionality.
 * 2. Instead, use either:
 *    - Style props and objects passed directly to components
 *    - Theme-aware style functions for consistent theming
 *    - Custom style constants for reusable configurations
 * 4. Numerical values:
 *    - Recharts properties (margins, heights, angles) must use raw numbers as they're used in SVG calculations
 *    - Regular CSS/MUI styling should use theme values (theme.spacing) and proper CSS units (px, rem)
 */

// Chart-specific style constants
export const axisStyles = (theme) => ({
  stroke: theme.palette.text.primary,
  fill: theme.palette.text.primary,
});

export const xAxisProps = (theme) => ({
  angle: -45,
  textAnchor: 'end',
  height: 80,
  stroke: theme.palette.text.primary,
});

export const barChartMargins = {
  top: 40,
  right: 30,
  left: 30,
  bottom: 40,
};

export const barProps = (theme) => ({
  fill: theme.colors.green,
  stroke: 'none',
  isAnimationActive: false,
});

export const barShape = (props) => <Rectangle {...props} stroke="none" />;

export const responsiveContainerProps = {
  width: '100%',
  height: 400,
};

export const tooltipProps = (theme) => ({
  contentStyle: {
    backgroundColor: theme.palette.background.secondary,
    color: theme.colors.white,
    border: 'none',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
  },
  cursor: false,
});
